// extracted by mini-css-extract-plugin
export var entries = "Entries-module--entries--9133e";
export var entry = "Entries-module--entry--00489";
export var pagination = "Entries-module--pagination--6e48e";